export interface Article {
  id: number;
  title: string;
  slug: string;
  description: string;
  category: string;
  categorySlug: string;
  tags: string[];
  coverImage: string;
  content: string;
  author: string;
  publishDate: string;
  updateDate: string;
  readTime: number;
  views: number;
  featured: boolean;
  hot: boolean;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-apps-line', description: '浏览全部打屁股漫画内容' },
  { name: '搞笑', slug: 'funny', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的打屁股漫画，让你笑到停不下来' },
  { name: '萌系', slug: 'cute', icon: 'ri-heart-line', description: '超萌Q版打屁股漫画，角色可爱到犯规' },
  { name: '剧情', slug: 'story', icon: 'ri-book-open-line', description: '有深度的剧情打屁股漫画，情节引人入胜' },
  { name: '治愈', slug: 'healing', icon: 'ri-sun-line', description: '温暖治愈的打屁股漫画，看完心里暖暖的' },
  { name: '日常', slug: 'daily', icon: 'ri-calendar-line', description: '日常系打屁股漫画，记录生活中的小趣味' },
];

export const articles: Article[] = [
  {
    id: 1,
    title: '教室里的搞笑惩罚：当班长变成捣蛋鬼',
    slug: 'classroom-funny-punishment',
    description: '原本一本正经的班长，今天居然带头捣乱？被老师抓个正着后的打屁股惩罚，笑料百出！',
    category: '搞笑',
    categorySlug: 'funny',
    tags: ['搞笑', '校园', '打屁股'],
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20illustration%20of%20a%20funny%20classroom%20scene%20with%20chibi%20characters%2C%20warm%20lighting%2C%20soft%20pastel%20colors%2C%20playful%20expression%2C%20manga%20cover%20art%20style%2C%20clean%20composition%2C%20cream%20background%2C%20adorable%20cartoon%20illustration&width=800&height=600&seq=manga-cover-01&orientation=landscape',
    content: '在一个阳光明媚的下午，一向严肃的班长小林突然决定放飞自我...',
    author: '漫画小站',
    publishDate: '2026-07-20',
    updateDate: '2026-07-20',
    readTime: 5,
    views: 12890,
    featured: true,
    hot: true,
  },
  {
    id: 2,
    title: '萌宠大作战：猫咪老师课堂开课啦',
    slug: 'cute-cat-teacher-class',
    description: '猫咪老师今天要给小动物们上课啦！调皮的小狗不听话，猫咪老师使出了绝招——打屁股！',
    category: '萌系',
    categorySlug: 'cute',
    tags: ['萌系', '动物', '打屁股'],
    coverImage: 'https://readdy.ai/api/search-image?query=Kawaii%20cat%20teacher%20in%20classroom%20with%20cute%20animal%20students%2C%20soft%20pastel%20colors%2C%20chibi%20style%2C%20warm%20and%20fluffy%20atmosphere%2C%20adorable%20manga%20cover%20illustration%2C%20cream%20background%2C%20gentle%20lighting&width=800&height=600&seq=manga-cover-02&orientation=landscape',
    content: '猫咪老师喵喵叫地走进教室，今天的学生们格外调皮...',
    author: '萌系工坊',
    publishDate: '2026-07-18',
    updateDate: '2026-07-19',
    readTime: 4,
    views: 9650,
    featured: true,
    hot: false,
  },
  {
    id: 3,
    title: '青梅竹马的日常：从小打到大的我们',
    slug: 'childhood-friends-daily-life',
    description: '从小一起长大的青梅竹马，打打闹闹的日常。今天又因为什么被青梅竹马打屁股了呢？',
    category: '日常',
    categorySlug: 'daily',
    tags: ['日常', '青梅竹马', '打屁股'],
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20chibi%20childhood%20friends%20in%20a%20sunny%20park%2C%20playful%20fighting%20scene%2C%20warm%20golden%20hour%20lighting%2C%20soft%20watercolor%20style%2C%20cute%20manga%20illustration%2C%20cream%20tone%20background%2C%20joyful%20atmosphere&width=800&height=600&seq=manga-cover-03&orientation=landscape',
    content: '小明和小花从小就是邻居，他们的日常就是各种打闹...',
    author: '日常漫画屋',
    publishDate: '2026-07-15',
    updateDate: '2026-07-15',
    readTime: 6,
    views: 15420,
    featured: false,
    hot: true,
  },
  {
    id: 4,
    title: '异世界转生：被打屁股的魔王大人',
    slug: 'isekai-demon-king-spanking',
    description: '勇者打败魔王后发现，惩罚魔王的最佳方式居然是打屁股？魔王从此过上了被日常打屁股的生活！',
    category: '搞笑',
    categorySlug: 'funny',
    tags: ['搞笑', '异世界', '打屁股'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chibi%20demon%20king%20getting%20playfully%20punished%20in%20fantasy%20castle%2C%20funny%20expression%2C%20warm%20magical%20atmosphere%2C%20soft%20colors%2C%20cute%20manga%20cover%20illustration%2C%20cream%20background%2C%20humorous%20fantasy%20scene&width=800&height=600&seq=manga-cover-04&orientation=landscape',
    content: '当勇者用剑指着魔王的时候，他突然想到了一个更好的主意...',
    author: '漫画小站',
    publishDate: '2026-07-12',
    updateDate: '2026-07-13',
    readTime: 7,
    views: 22100,
    featured: true,
    hot: true,
  },
  {
    id: 5,
    title: '姐妹情深：姐姐的温柔惩罚',
    slug: 'sisters-gentle-punishment',
    description: '妹妹在学校闯祸了，姐姐既生气又心疼。温柔的惩罚背后，是说不出口的关心与爱。',
    category: '治愈',
    categorySlug: 'healing',
    tags: ['治愈', '姐妹', '打屁股'],
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20sisters%20in%20cozy%20bedroom%2C%20older%20sister%20gently%20scolding%20younger%20one%2C%20warm%20sunset%20light%20through%20window%2C%20soft%20watercolor%20manga%20style%2C%20heartwarming%20atmosphere%2C%20cream%20background%2C%20emotional%20illustration&width=800&height=600&seq=manga-cover-05&orientation=landscape',
    content: '阳光透过窗帘洒在房间里，姐姐静静地看着妹妹的成绩单...',
    author: '治愈系画室',
    publishDate: '2026-07-10',
    updateDate: '2026-07-10',
    readTime: 5,
    views: 18760,
    featured: false,
    hot: false,
  },
  {
    id: 6,
    title: '魔法学院：调皮的见习魔女',
    slug: 'magic-academy-naughty-witch',
    description: '魔法学院里最调皮的见习魔女，每天都要被导师惩罚。但今天她发现自己不小心放出了一个不得了的咒语！',
    category: '剧情',
    categorySlug: 'story',
    tags: ['剧情', '魔法', '打屁股'],
    coverImage: 'https://readdy.ai/api/search-image?query=Young%20witch%20in%20magic%20academy%20classroom%2C%20sparkling%20magic%20effects%2C%20chibi%20style%2C%20warm%20candlelight%20atmosphere%2C%20soft%20fantasy%20colors%2C%20cute%20manga%20illustration%2C%20cream%20background%2C%20magical%20ambience&width=800&height=600&seq=manga-cover-06&orientation=landscape',
    content: '魔法学院的大钟敲响，新的一天开始了。见习魔女莉莉丝一如既往地迟到了...',
    author: '剧情绘馆',
    publishDate: '2026-07-08',
    updateDate: '2026-07-09',
    readTime: 8,
    views: 25600,
    featured: true,
    hot: true,
  },
  {
    id: 7,
    title: '呆萌兔兔的惩罚日记',
    slug: 'silly-bunny-punishment-diary',
    description: '一只呆萌的小兔子，每天都在家里闯祸。兔妈妈的惩罚虽然疼，但满满都是爱呢！',
    category: '萌系',
    categorySlug: 'cute',
    tags: ['萌系', '动物', '打屁股'],
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20bunny%20family%20in%20cozy%20burrow%20home%2C%20baby%20bunny%20looking%20guilty%2C%20soft%20warm%20lighting%2C%20kawaii%20chibi%20style%2C%20pastel%20pink%20and%20cream%20tones%2C%20adorable%20manga%20cover%20art%2C%20fluffy%20textures&width=800&height=600&seq=manga-cover-07&orientation=landscape',
    content: '兔兔今天又做了什么好事呢？让我们翻开它的惩罚日记看看吧...',
    author: '萌系工坊',
    publishDate: '2026-07-06',
    updateDate: '2026-07-06',
    readTime: 4,
    views: 11030,
    featured: false,
    hot: false,
  },
  {
    id: 8,
    title: '办公室日常：老板的特别培训',
    slug: 'office-daily-boss-training',
    description: '新来的实习生总是犯错，老板决定用一种特别的方式进行培训。办公室里的打屁股日常开始了！',
    category: '日常',
    categorySlug: 'daily',
    tags: ['日常', '办公室', '打屁股'],
    coverImage: 'https://readdy.ai/api/search-image?query=Funny%20office%20scene%20with%20chibi%20characters%2C%20boss%20and%20intern%2C%20playful%20workplace%20atmosphere%2C%20warm%20lighting%2C%20soft%20colors%2C%20cute%20manga%20cover%20illustration%2C%20cream%20background%2C%20humorous%20corporate%20theme&width=800&height=600&seq=manga-cover-08&orientation=landscape',
    content: '周一早上九点，实习生小王又迟到了...',
    author: '日常漫画屋',
    publishDate: '2026-07-04',
    updateDate: '2026-07-05',
    readTime: 5,
    views: 14300,
    featured: false,
    hot: true,
  },
  {
    id: 9,
    title: '精灵森林的秘密惩罚法则',
    slug: 'elf-forest-secret-punishment',
    description: '在精灵森林里，每个犯了错的小精灵都要接受森林长老的打屁股惩罚。今天轮到谁了呢？',
    category: '剧情',
    categorySlug: 'story',
    tags: ['剧情', '精灵', '打屁股'],
    coverImage: 'https://readdy.ai/api/search-image?query=Enchanted%20forest%20with%20tiny%20elf%20characters%2C%20elder%20elf%20and%20mischievous%20young%20elf%2C%20soft%20magical%20glow%2C%20warm%20fairy%20tale%20colors%2C%20chibi%20manga%20style%2C%20cream%20background%2C%20whimsical%20atmosphere&width=800&height=600&seq=manga-cover-09&orientation=landscape',
    content: '在人类看不见的精灵森林深处，有一套独特的规则...',
    author: '剧情绘馆',
    publishDate: '2026-07-02',
    updateDate: '2026-07-03',
    readTime: 7,
    views: 19800,
    featured: true,
    hot: false,
  },
  {
    id: 10,
    title: '小熊猫的淘气一天',
    slug: 'little-panda-naughty-day',
    description: '小熊猫今天趁妈妈不注意，偷偷溜出去玩了一整天。回家后会怎样呢？当然是打屁股啦！',
    category: '萌系',
    categorySlug: 'cute',
    tags: ['萌系', '动物', '打屁股'],
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20baby%20panda%20getting%20scolded%20by%20mama%20panda%20in%20bamboo%20forest%2C%20chibi%20style%2C%20soft%20green%20and%20cream%20tones%2C%20warm%20sunlight%2C%20adorable%20manga%20cover%20illustration%2C%20fluffy%20and%20kawaii&width=800&height=600&seq=manga-cover-10&orientation=landscape',
    content: '清晨的阳光洒在竹林里，小熊猫圆圆偷偷睁开了眼睛...',
    author: '萌系工坊',
    publishDate: '2026-06-30',
    updateDate: '2026-06-30',
    readTime: 3,
    views: 8720,
    featured: false,
    hot: false,
  },
  {
    id: 11,
    title: '剑道少女的修行之路',
    slug: 'kendo-girl-training-path',
    description: '想要成为最强剑士的少女，每天都要接受师傅严格的训练。做错了就要被打屁股惩罚！',
    category: '剧情',
    categorySlug: 'story',
    tags: ['剧情', '剑道', '打屁股'],
    coverImage: 'https://readdy.ai/api/search-image?query=Young%20kendo%20girl%20training%20in%20traditional%20dojo%2C%20determined%20expression%2C%20warm%20wooden%20interior%2C%20soft%20sunlight%2C%20chibi%20manga%20style%2C%20inspirational%20atmosphere%2C%20cream%20background%2C%20martial%20arts%20theme&width=800&height=600&seq=manga-cover-11&orientation=landscape',
    content: '樱花飘落的季节，少女千寻踏入了传说中的剑道馆...',
    author: '剧情绘馆',
    publishDate: '2026-06-28',
    updateDate: '2026-06-29',
    readTime: 9,
    views: 31200,
    featured: true,
    hot: true,
  },
  {
    id: 12,
    title: '暖心的惩罚：妈妈的味道',
    slug: 'heartwarming-punishment-moms-love',
    description: '小时候总觉得被打屁股是天大的事。长大后才明白，那是最温暖的爱的表达。',
    category: '治愈',
    categorySlug: 'healing',
    tags: ['治愈', '亲情', '打屁股'],
    coverImage: 'https://readdy.ai/api/search-image?query=Mother%20and%20child%20in%20warm%20kitchen%2C%20nostalgic%20atmosphere%2C%20soft%20golden%20light%2C%20watercolor%20manga%20style%2C%20emotional%20and%20heartwarming%20illustration%2C%20cream%20background%2C%20love%20and%20care%20theme&width=800&height=600&seq=manga-cover-12&orientation=landscape',
    content: '每当闻到厨房里飘来的香味，我就想起小时候...',
    author: '治愈系画室',
    publishDate: '2026-06-25',
    updateDate: '2026-06-26',
    readTime: 5,
    views: 16700,
    featured: false,
    hot: false,
  },
  {
    id: 13,
    title: '校园喜剧：学生会长的秘密',
    slug: 'school-comedy-student-president-secret',
    description: '高高在上的学生会长居然有个不为人知的秘密——她最害怕的就是被副校长打屁股！',
    category: '搞笑',
    categorySlug: 'funny',
    tags: ['搞笑', '校园', '打屁股'],
    coverImage: 'https://readdy.ai/api/search-image?query=Funny%20school%20scene%20with%20student%20council%20president%20looking%20nervous%2C%20chibi%20characters%2C%20bright%20classroom%2C%20warm%20lighting%2C%20humorous%20manga%20cover%20art%2C%20cream%20background%2C%20comedy%20theme&width=800&height=600&seq=manga-cover-13&orientation=landscape',
    content: '学生会办公室的门被推开，副会长气喘吁吁地冲了进来...',
    author: '漫画小站',
    publishDate: '2026-06-22',
    updateDate: '2026-06-23',
    readTime: 6,
    views: 20400,
    featured: false,
    hot: true,
  },
  {
    id: 14,
    title: '狗狗警官的巡逻日常',
    slug: 'dog-police-patrol-daily',
    description: '汪汪警官是动物城最受欢迎的警察，他惩罚坏人的方式就是——打屁股！萌到犯规的执法现场。',
    category: '萌系',
    categorySlug: 'cute',
    tags: ['萌系', '动物', '打屁股'],
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20dog%20police%20officer%20in%20animal%20city%2C%20patrol%20scene%2C%20kawaii%20chibi%20style%2C%20warm%20sunny%20day%2C%20soft%20pastel%20colors%2C%20adorable%20manga%20cover%20illustration%2C%20cream%20background%2C%20playful%20law%20enforcement%20theme&width=800&height=600&seq=manga-cover-14&orientation=landscape',
    content: '清晨的动物城，汪汪警官戴上警帽，开始了新一天的巡逻...',
    author: '萌系工坊',
    publishDate: '2026-06-20',
    updateDate: '2026-06-20',
    readTime: 4,
    views: 13500,
    featured: false,
    hot: false,
  },
  {
    id: 15,
    title: '夏日的蝉鸣与你的惩罚',
    slug: 'summer-cicadas-and-your-punishment',
    description: '暑假的最后一天，作业还一字未动。姐姐的惩罚伴随着窗外的蝉鸣，成为了那年夏天最深刻的记忆。',
    category: '治愈',
    categorySlug: 'healing',
    tags: ['治愈', '夏天', '打屁股'],
    coverImage: 'https://readdy.ai/api/search-image?query=Summer%20afternoon%20in%20Japanese%20style%20room%2C%20two%20siblings%2C%20cicada%20sounds%20atmosphere%2C%20warm%20sunlight%20through%20window%2C%20nostalgic%20watercolor%20manga%20style%2C%20cream%20background%2C%20bittersweet%20summer%20memory&width=800&height=600&seq=manga-cover-15&orientation=landscape',
    content: '蝉鸣声从窗外传来，电风扇吱呀吱呀地转着...',
    author: '治愈系画室',
    publishDate: '2026-06-18',
    updateDate: '2026-06-18',
    readTime: 5,
    views: 11900,
    featured: false,
    hot: false,
  },
];

export const faqs = [
  { question: '打屁股漫画是什么类型的漫画？', answer: '打屁股漫画是一种以打屁股为主题或关键情节的漫画类型，涵盖搞笑、萌系、剧情、治愈、日常等多种风格。内容活泼有趣，适合喜欢轻松愉快漫画的读者。' },
  { question: '网站上的漫画多久更新一次？', answer: '我们致力于每周更新2-3篇新的漫画内容，节假日会有特别企划，确保读者能够持续获取最新最有趣的打屁股漫画资源。' },
  { question: '可以投稿自己的漫画作品吗？', answer: '当然可以！我们非常欢迎漫画作者投稿。请通过关于我们页面的联系方式与我们取得联系，我们会认真审阅每一份投稿。' },
  { question: '网站上的漫画是否收费？', answer: '目前所有漫画内容均为免费阅读，我们致力于为漫画爱好者提供一个开放、免费的阅读平台。' },
  { question: '如何找到自己感兴趣的漫画类型？', answer: '您可以通过首页的分类导航进入您感兴趣的分类页面，或者使用搜索功能查找特定标签的漫画内容。' },
];

export const testimonials = [
  { name: '漫画迷小李', avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20happy%20boy%2C%20chibi%20style%2C%20warm%20colors%2C%20soft%20pastel%2C%20simple%20background&width=100&height=100&seq=avatar-01&orientation=squarish', comment: '发现这个网站真的太开心了！每天都要来看看有没有更新，漫画质量超棒！' },
  { name: '日常爱好者', avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20smiling%20girl%2C%20chibi%20style%2C%20warm%20colors%2C%20soft%20pastel%2C%20simple%20background&width=100&height=100&seq=avatar-02&orientation=squarish', comment: '日常系列的漫画太有共鸣了，感觉就像在画我的生活，每篇都追着看！' },
  { name: '萌系控小糖', avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20girl%20with%20cat%20ears%2C%20chibi%20style%2C%20warm%20colors%2C%20soft%20pastel%2C%20simple%20background&width=100&height=100&seq=avatar-03&orientation=squarish', comment: '萌系分类简直是我的快乐源泉！画风太可爱了，每一篇都保存了！' },
  { name: '剧情深度读', avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20thoughtful%20boy%2C%20chibi%20style%2C%20warm%20colors%2C%20soft%20pastel%2C%20simple%20background&width=100&height=100&seq=avatar-04&orientation=squarish', comment: '剧情的漫画不止有趣还有深度，作者真的很用心在创作，强烈推荐！' },
];